<div class="center">
    <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <app-banner-alert></app-banner-alert>
        <!-- New Password Field -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Password</mat-label>
            <input matInput maxlength="12" [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" required
                autocomplete="new-password" autocomplete="off" autocorrect="off"
                spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
            <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword"
                [attr.aria-label]="'Hide password'">
                <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="newPassword?.errors?.['required']">New password is required</mat-error>
            <mat-error *ngIf="newPassword?.errors?.['passwordComplexity']">
                Password must contain uppercase, lowercase letters, numbers, and special characters
            </mat-error>
            <mat-error *ngIf="newPassword?.errors?.['minlength']">
                Password must contain minimum 8 characters
            </mat-error>
            <mat-hint [align]="'end'">{{newPassword?.value?.length || 0 }} / 12</mat-hint>
        </mat-form-field>

        <!-- Re-enter Password Field -->
        <mat-form-field appearance="outline" class="full-width" style="margin-top: 55px;">
            <mat-label>Re-enter New Password</mat-label>
            <input matInput [type]="hideReenterPassword ? 'password' : 'text'" formControlName="reenterPassword"
                required autocomplete="new-password" autocomplete="off" autocorrect="off"
                spellcheck="false" (copy)="false" (cut)="false" (paste)="false">
            <button mat-icon-button matSuffix (click)="hideReenterPassword = !hideReenterPassword"
                [attr.aria-label]="'Hide password'">
                <mat-icon>{{hideReenterPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error *ngIf="reenterPassword?.errors?.['required']">Please re-enter the password</mat-error>
            <mat-error *ngIf="changePasswordForm.errors?.['passwordsMismatch']">
                Passwords do not match
            </mat-error>
        </mat-form-field>

        <!-- Password Strength Indicator -->
        <div *ngIf="passwordStrength" style="margin-top: 30px;" class="password-strength center" [style.color]="passwordStrengthColor">
            Password Strength: {{ passwordStrength }}
        </div>

        <!-- Submit Button -->
        <div class="center" style="margin-top: 50px;">
            <button mat-stroked-button (click)="backToLogin()" style="margin-right: 10px;">Back to Login</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="changePasswordForm.invalid">
                Change Password
            </button>
        </div>

    </form>
</div>